import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {KeyboardArrowLeft} from "../../icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../icons/keyboard-arrow/keyboard-arrow-right";

class SeeAllFooterButtonProps extends BaseProps {
  buttonLabel: String;
  isRtl: Boolean;
}

export const SeeAllFooterButton = (props: SeeAllFooterButtonProps) => {
  return (
    <div className={'see-all-footer-button-container'}>
      <span>
         &nbsp; &nbsp; &nbsp;
        {
         props.buttonLabel
        }
        &nbsp;
      </span>
      <span>
        {
          props.isRtl ? <KeyboardArrowLeft className={'see-all-footer-button-arrow'}/> : <KeyboardArrowRight className={'see-all-footer-button-arrow'} />
        }
      </span>
    </div>
  )
}

